module.exports = __webpack_public_path__ + "img/pr-4.418c911d.png";